import { SubmitDataType } from "@data-types/sow/PlayerSowTypes";
import {
	httpClient,
	getAgencyKey,
	getApplicationHeaders,
	UserTypes,
} from "@utils";

import {
	SowQuestionResponse,
	SowSubmissionResponse,
} from "@api-types/sow/PlayerSowApiTypes";
class PlayerSowApiService {
	static baseUrl(activeUser = UserTypes.PRIMARY) {
		return `${WEBPACK_BASE_ADDRESS}${getAgencyKey(activeUser)}/sow`;
	}

	static questionsUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/sow-questions?embed=SOWQuestionOptions&translate=true`;
	}

	static checkUser(userId: string) {
		if (App.state.rootStore.userAuthStore.secondaryUser?.id === userId) {
			return UserTypes.SECONDARY;
		} else {
			return UserTypes.PRIMARY;
		}
	}

	static getRequestHeadersGet(activeUser = UserTypes.PRIMARY) {
		const appHeaders = getApplicationHeaders(activeUser);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	}

	static getRequestHeadersPost(activeUser = UserTypes.PRIMARY) {
		const appHeaders = getApplicationHeaders(activeUser);
		return appHeaders;
	}

	static async getSowQuestions(): Promise<SowQuestionResponse> {
		const response = await httpClient.get(
			this.questionsUrl(),
			this.getRequestHeadersGet(),
			{
				responseType: "json",
			}
		);
		return response;
	}

	static async getSowSubmissionStatus(
		requestId: string,
		userId: string
	): Promise<SowSubmissionResponse> {
		const userType = this.checkUser(userId);

		const response = await httpClient.get(
			`${this.baseUrl(userType)}/submission-status/${requestId}/${userId}`,
			this.getRequestHeadersGet(userType),
			{
				responseType: "json",
			},
			"home"
		);

		return response;
	}

	static async submitSow(data: SubmitDataType): Promise<any> {
		const formData = new FormData();

		const userType = this.checkUser(data.userId);

		data.files.forEach((file) => {
			formData.append("file", file);
		});

		formData.append("fileData", JSON.stringify(data.fileData));
		formData.append("message", data.message);
		formData.append("requestId", data.requestId);
		formData.append("userId", data.userId);
		formData.append("answers", JSON.stringify(data.answers));
		formData.append("isAccepted", JSON.stringify(data.isAccepted));

		return await httpClient.post(
			`${this.baseUrl(userType)}/submit`,
			formData,
			this.getRequestHeadersPost(userType),
			{
				responseType: "json",
			}
		);
	}
}

export default PlayerSowApiService;
